import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatCardProps {
  label: string;
  value: ReactNode;
  valueColor?: string;
  caption?: string;
  footer?: ReactNode;
}

/**
 * A flat, bordered headline-metric card: a primary label, a large value, and
 * an optional secondary caption or richer footer (e.g. a trend indicator).
 */
export const StatCard = ({
  label,
  value,
  valueColor,
  caption,
  footer,
}: StatCardProps) => (
  <Box sx={{ border: 1, borderColor: "grey.300", borderRadius: 1, p: 2 }}>
    <Typography variant="h6" color="primary">
      {label}
    </Typography>
    <Typography variant="h4" color={valueColor}>
      {value}
    </Typography>
    {footer ??
      (caption ? (
        <Typography variant="caption" color="text.secondary">
          {caption}
        </Typography>
      ) : null)}
  </Box>
);
